import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { uploadProductImage } from "../../services/imageApi";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import "./AddProductImages.css";

const MAX_IMAGES = 4;

const AddProductImages = () => {
    const { productId } = useParams();
    const navigate = useNavigate();

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);

    // handle file select
    const handleChange = (e) => {
        const files = Array.from(e.target.files);

        // total limit check
        if (files.length + images.length > MAX_IMAGES) {
            alert(`You can select maximum ${MAX_IMAGES} images total`);
            return;
        }

        setImages((prev) => [...prev, ...files]);

        // reset input so same file can be selected again if needed
        e.target.value = "";
    };

    // remove single image before upload
    const removeImage = (index) => {
        setImages((prev) => prev.filter((_, i) => i !== index));
    };

    // upload all images
    const handleUpload = async () => {
        if (images.length === 0) {
            alert("Please select images first");
            return;
        }

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("product_id", productId);

            // IMPORTANT: must match backend multer field name
            images.slice(0, MAX_IMAGES).forEach((file) => {
                formData.append("images", file);
            });

            await uploadProductImage(formData);

            alert("Images uploaded successfully");
            navigate("/admin/products");

        } catch (err) {
            alert(err.response?.data?.message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="add-images-layout">

            <Sidebar role="admin" />

            <div className="add-images-main">

                <Navbar />

                <div className="add-images-content">

                    <div className="add-images-card">

                        <h2 className="add-images-title">
                            Add Product Images
                        </h2>

                        {/* MULTI SELECT INPUT */}
                        <div className="file-section">

                            <label className="file-label">
                                Select Product Images
                            </label>

                            <input
                                className="file-input"
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleChange}
                            />

                            <p className="image-limit-text">
                                You can select up to {MAX_IMAGES} images total
                                ({images.length}/{MAX_IMAGES})
                            </p>

                        </div>

                        {/* PREVIEW */}
                        {images.length > 0 && (
                            <div className="preview-section">

                                <h3 className="preview-title">
                                    Image Preview
                                </h3>

                                <div className="image-preview-grid">

                                    {images.map((img, index) => (
                                        <div
                                            className="image-preview-item"
                                            key={index}
                                        >

                                            <img
                                                src={URL.createObjectURL(img)}
                                                alt={`preview-${index}`}
                                                className="preview-image"
                                            />

                                            <button
                                                type="button"
                                                className="remove-image-btn"
                                                onClick={() =>
                                                    removeImage(index)
                                                }
                                            >
                                                X
                                            </button>

                                        </div>
                                    ))}

                                </div>

                            </div>
                        )}

                        {/* UPLOAD BUTTON */}
                        <button
                            type="button"
                            className="upload-images-btn"
                            onClick={handleUpload}
                            disabled={loading}
                        >
                            {loading
                                ? "Uploading..."
                                : "Upload Images"}
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default AddProductImages;
